import { observer } from 'mobx-react-lite';

import { Table } from '@/components/table';
import { useMassUpdateCashedRelStores } from '@/utils/store';

import { getColumns } from './setup';
import { lotWaybillStore } from '@/stores';

const store = lotWaybillStore;

export const Waybills = observer(({ lotId }: { lotId: number }) => {
  const items = store.items;
  useMassUpdateCashedRelStores([store], lotId);

  const columns = getColumns(lotId);

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={[...items]}
      store={store}
      loading={store.loading}
      scroll={{ x: 950 }}
      relId={lotId}
    />
  );
});
